import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle } from "react-icons/fa";
import axios from 'axios';

const Dashboard = () => {
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    useEffect(() => {
        if (user?.id) fetchEvents();
    }, [user]);

    const fetchEvents = async () => {
        try {
            const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
            setEvents(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleNavigation = (path) => navigate(path);

    const handleLogout = () => {
        sessionStorage.clear();
        alert('You have been logged out!');
        navigate('/');
    };

    return (
        <div className="d-flex flex-column min-vh-100" style={{ fontFamily: 'Segoe UI, sans-serif' }}>
            <div className="py-4 flex-grow-1">
                <div className="d-flex justify-content-between align-items-center bg-light rounded p-3 shadow-sm mb-4">
                    <img src={events.find((event) => event.flag === 1)?.file || 'https://via.placeholder.com/100'} alt="Logo" className="img-fluid" style={{ maxWidth: '100px' }} />
                    <h3 className="text-center flex-grow-1 text-primary fw-bold mb-0">
                        {events[0]?.name || 'No event available'}
                    </h3>
                    <FaUserCircle size={28} className="text-secondary cursor-pointer" onClick={handleLogout} />
                </div>

                <div className="container-fluid px-4">
                    <div className="row text-center g-3">
                        <div className="col-md-3 col-sm-6">
                            <button className="btn btn-success w-100 py-3 shadow-sm" onClick={() => handleNavigation('/QuestionnaireForm/253643/QuestionnaireForm')}>Quiz</button>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <button className="btn btn-primary w-100 py-3 shadow-sm" onClick={() => handleNavigation('/PollQuestionForm/45g63476tr/PollQuestionForm')}>Poll</button>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <button className="btn btn-warning w-100 py-3 shadow-sm" onClick={() => handleNavigation('/QuizResults/45g63476tr/QuizResults')}>Quiz Results</button>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <button className="btn btn-dark w-100 py-3 shadow-sm" onClick={() => handleNavigation('/createnewevent/25g4643')}>Create New Event</button>
                        </div>

                        <div className="col-md-3 col-sm-6">
                            <button className="btn btn-success w-100 py-3 shadow-sm" onClick={() => handleNavigation('/quiz')}>+ADD Quiz</button>
                        </div>
                    </div>
                </div>
            </div>

            <footer className="bg-dark text-white text-center py-3 mt-auto">
                <p className="mb-0">© 2025 E-medha technologies. All rights reserved.</p>
            </footer>
        </div >
    );
};

export default Dashboard;
